import SystemService from "../../service/SystemService";
// import swal from 'sweetalert'

//export const namespaced = true

//
// const getDefaultState = () => {
//     return {
//         appLoading: true,
//         moduleLoading: false,
//         moduleLoadingTwo: false,
//         moduleLoadingThree: false
//     };
// };
//
// export const state = getDefaultState();

export const state = {
    baseUrl: 'https://92q1ktaln3.execute-api.us-east-1.amazonaws.com/dev/',
    baseUrl2: 'https://m2nz1o078e.execute-api.us-east-1.amazonaws.com/dev/',
    baseUrl3: 'https://cors-anywhere.herokuapp.com/http://zeegnal.octopuszone.com/corpapi/api/operations/',
    appLoading: false,
    dashboard:{
        detailsPer:0,
        officersPer:0,
        docsPer:0,
        data:[]
    },
    isUserInfoUpt: false,
    isTwoFa: false,
    isDashboardUpt: false,
    userInfoLoading:false,
    dashboardLoading: true,
    switchLoading: true,
    userInfo:null

}

export const getters = {
    userInfo: state=>{
        return state.userInfo
    }
}


export const mutations = {
    updateUserInfo(state, payload){
        // console.log('Entered Mutation', payload);
        state.userInfo = payload;
    },

    updateDashboard(state, payload){
        state.dashboard = payload;
    },

    updateDashboardData(state, payload){
        state.dashboard.data = payload;
    },

    updateAppLoading: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.appLoading = payload;
    },

    updateIsTwoFa: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.isTwoFa = payload;
    },

    resetApp: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        payload = false;
        state.isDashboardUpt= payload;
        state.userInfo.firstName = null;
    },

    resetAppTwo: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        payload = false;
        state.isDashboardUpt = payload;
    },

    updateIsDashboardUpt: (state, payload) =>{
        // console.log('Entered Mutation updateIsExpensesUpt = ', payload);

        state.isDashboardUpt = payload;
    },

    updateIsUserInfoUpt: (state, payload) =>{
        // console.log('Entered Mutation', payload);

        state.isUserInfoUpt = payload;
    },

    updateUserInfoLoading: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.userInfoLoading = payload;
    },

    updateDashboardLoading: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.dashboardLoading = payload;
    },
    // eslint-disable-next-line no-unused-vars
    reset: (state, payload) =>{
        state.baseUrl = 'https://92q1ktaln3.execute-api.us-east-1.amazonaws.com/dev/',
            state.baseUrl2 = 'https://m2nz1o078e.execute-api.us-east-1.amazonaws.com/dev/',
            state.baseUrl3 = 'https://cors-anywhere.herokuapp.com/http://zeegnal.octopuszone.com/corpapi/api/operations/',
            state.appLoading = false,
            state.dashboard = {
                detailsPer:0,
                officersPer:0,
                docsPer:0
            };
        state.isUserInfoUpt = false,
            state.isDashboardUpt = false,
            state.userInfoLoading =false,
            state.dashboardLoading = false,
            state.userInfo = null
    },

}


export const actions = {
    updateDashboard: ({ commit }, payload)=>{
        // console.log("updateDashboard>>>>>>")
        commit("updateDashboardLoading", true)
        return SystemService.callGetDashboardApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    commit("updateDashboardLoading", false)
                    commit("updateIsDashboardUpt", true)
                    let responseData = response.data;
                    commit("updateDashboard", responseData)
                }

            })
            // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateDashboardLoading", false)
                // alert(error)
                // throw error;
            });
    },

    updateIsUserInfoUpt: ({ commit }, payload)=>{
        commit('updateIsUserInfoUpt', payload)
    },

    updateUserInfo: ({ commit }, payload={payload:"you"})=>{
        // console.log("updateUserInfoLoading>>>>>>")
        // console.log(localStorage.q_auth)
        payload.countrycode = "234"
        payload.accountnumber = localStorage.username
        payload.mobilenumber = localStorage.username
        payload.querytype = "mobilenumber"
        commit("updateUserInfoLoading", true)
        return SystemService.callGetUserInfoApi(payload)
        // .then(response => {
        //     if (response.data.responseCode === "00") {
        //         commit("updateUserInfoLoading", false)
        //         commit("updateIsUserInfoUpt", true)
        //         let responseData = response.data;
        //         commit("updateUserInfo", responseData)
        //     }
        //
        // })
        //     // eslint-disable-next-line no-unused-vars
        // .catch(error => {
        //     commit("updateUserInfoLoading", false)
        //     // alert(error)
        //     // throw error;
        // });
    },

    updateTwoFaInfo: ({ commit }, payload={payload:"you"})=>{
        payload.userId =  state.userInfo.id
        commit("updateUserInfoLoading", true)
        return SystemService.callGetUserInfoApi(payload)
    },

    updateDashboardWithoutLoader: ({ commit }, payload)=>{
        commit('updateDashboardWithoutLoader', payload)
    },

    updateAppLoading: ({ commit }, payload)=>{
        commit('updateAppLoading', payload)
    },

    updateIsDashboardUpt: ({ commit }, payload)=>{
        commit('updateIsDashboardUpt', payload)
    },

    resetApp: ({ commit }, payload)=>{
        commit('resetApp', payload)
    },

    resetAppTwo: ({ commit }, payload)=>{
        commit('resetAppTwo', payload)
    },

    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }
}
